export var ensureExists = function (item, msg) {
    if (typeof item === 'undefined' || item === null) {
        throw (msg || 'Variable is null or undefined');
    }
    return item;
};
//# sourceMappingURL=index.js.map